export default __webpack_public_path__ + "static/media/CheckMark.63d0f7ef.svg";